import { ScriptLoaderEvents } from './enums';
import { EventEmitterBase } from './event-emitter-base';

export class ScriptLoader extends EventEmitterBase {

    require(url: string | Array<string>): Promise<string | string[]> {

        if (url instanceof Array) {
            return this.requireScripts(url);
        }
        return this.requireScript(url);
    }

    requireAsync(url: string | Array<string>): Promise<string | string[]> {
        if (url instanceof Array) {
            return this.requireScripts(url);
        }
        return this.requireScript(url, true);
    }

    requireCode(code: string, async?: boolean): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.checkCodeAlreadyLoaded(code)) {
                resolve();
                return;
            }
            const head: HTMLHeadElement = document.getElementsByTagName('head')[0];
            const script: HTMLScriptElement = document.createElement('script');

            if (async) {
                script.async = true;
            }
            script.innerHTML = code;

            head.appendChild(script);
            resolve();
        });
    }

    private requireScripts(urls: string[], async?: boolean): Promise<string[]> {
        return Promise.all(urls.map(url => this.requireScript(url, async)));
    }

    private requireScript(url: string, async?: boolean): Promise<string> {
        return new Promise((resolve, reject) => {
            if (this.checkScriptAlreadyLoaded(url)) {
                resolve(url);
                return;
            }
            const head: HTMLHeadElement = document.head;
            const script: HTMLScriptElement = document.createElement('script');

            if (async) {
                script.async = true;
            }
            script.src = url;
            head.appendChild(script);

            script.onerror = () => {
                this.emit(ScriptLoaderEvents.ScriptLoadedError);
                reject({
                    name: 900600,
                    message: `There was an error while trying to load '${url}' dynamically`,
                });
            };

            script.onload = () => {
                this.emit(ScriptLoaderEvents.ScriptLoaded, url);
                resolve(url);
            };
        });
    }

    private checkScriptAlreadyLoaded(url: string): boolean {
        const scripts: HTMLCollectionOf<HTMLScriptElement> = document.getElementsByTagName('script');
        const length: number = scripts.length;
        let loaded = false;
        for (let i = 0; i < length; i++) {
            if (scripts.item(i).src === url) {
                loaded = true;
            }
        }

        return loaded;
    }

    private checkCodeAlreadyLoaded(code: string): boolean {
        const scripts: HTMLCollectionOf<HTMLScriptElement> = document.getElementsByTagName('script');
        const length: number = scripts.length;
        let loaded = false;
        for (let i = 0; i < length; i++) {
            if (scripts.item(i).innerHTML.trim() === code.trim()) {
                loaded = true;
            }
        }

        return loaded;
    }
}
